import { useRef, useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import { NavBar } from '../../utility/navBar/Navbar';
import CommonButton from '../../utility/components/CommonButton';
import formBackgroundImg from '../../assets/img/contact-form-background.jpg';
import config from '../../config';
import 'animate.css';
import './ContactForm.css';

const text = {
    title: "Contact Us",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    phone: "Phone",
    message: "Message",
    submit: "Submit"
};

const { serviceId: SERVICE_ID, templateId: TEMPLATE_ID, publicKey: PUBLIC_KEY } = config.emailjs;

export const ContactForm = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0});
    }, []);

    const formRef = useRef(null);
    const [statusMessage, setStatusMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (isSubmitting) return;
        setIsSubmitting(true);
        setStatusMessage("");

        const formData = new FormData(formRef.current);
        const firstName = formData.get("firstName").trim();
        const lastName = formData.get("lastName").trim();
        const email = formData.get("email").trim();
        const phone = formData.get("phone").trim();
        const message = formData.get("message").trim();

        if (!firstName || !lastName || !email || !phone || !message) {
            setStatusMessage("Please fill in all fields.");
            setIsSubmitting(false);
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setStatusMessage("Invalid email address.");
            setIsSubmitting(false);
            return;
        }

        const phoneRegex = /^[0-9]{7,15}$/;
        if (!phoneRegex.test(phone)) {
            setStatusMessage("Invalid phone number.");
            setIsSubmitting(false);
            return;
        }

        emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY)
        .then(
            (response) => {
                console.log("SUCCESS!", response.status, response.text);
                setStatusMessage("Message sent successfully!");
                formRef.current.reset();
            },
            (error) => {
                console.error("FAILED...", error);
                setStatusMessage("Failed to send message. Please try again.");
            }
        )
        .finally(() => {
            setIsSubmitting(false);
        });
    };

    return (
        <>
            <NavBar theme='light' />
            <section className="form">
                <div className="form__background-img">
                    <img src={formBackgroundImg} alt="Contact Form Background"/>
                </div>
                <div className="form__container">
                    <div className='background-pattern animate__animated animate__fadeIn'>
                        <p className='title'>Hong Kong</p>
                        <p className='emphasizer '>Architect</p>
                    </div>
                    <h1>{text.title}</h1>
                    <form ref={formRef} onSubmit={handleSubmit}>
                        <div className="name-fields">
                            <div>
                                <label>{text.firstName}</label>
                                <input type="text" name="firstName" required />
                            </div>
                            <div>
                                <label>{text.lastName}</label>
                                <input type="text" name="lastName" required />
                            </div>
                        </div>
                        <div>
                            <label>{text.email}</label>
                            <input type="email" name="email" required />
                        </div>
                        <div>
                            <label>{text.phone}</label>
                            <input type="tel" name="phone" required />
                        </div>
                        <div>
                            <label>{text.message}</label>
                            <textarea name="message" required></textarea>
                        </div>
                        <CommonButton 
                            type="submit" 
                            className='contact__button' 
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Sending..." : text.submit}
                        </CommonButton>
                    </form>
                    {statusMessage && <p className="status-message">{statusMessage}</p>}
                </div>
            </section>
        </>
    );
};
